import { render, staticRenderFns } from "./blessPage.vue?vue&type=template&id=1877ca2f&scoped=true&"
import script from "./blessPage.vue?vue&type=script&lang=js&"
export * from "./blessPage.vue?vue&type=script&lang=js&"
import style0 from "./blessPage.vue?vue&type=style&index=0&id=1877ca2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1877ca2f",
  null
  
)

component.options.__file = "blessPage.vue"
export default component.exports